module.exports = __webpack_public_path__ + "static/media/mask.15f151d1.png";